import { FieldTypes } from 'forms-utils-lib/constants/formField/FieldTypeMapping';
import { FormFieldPropertyObjectTypes, FormFieldPropertyObjectTypesIds } from 'forms-utils-lib/constants/PropertyObjectTypes';
import FieldType from 'forms-utils-lib/constants/formField/FieldType';
import defaultValidation from 'forms-utils-lib/formField/constants/defaultValidation';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
const defaultDependentCompanyFormField = {
  [FormFieldKeys.DEFAULT_VALUE]: '',
  [FormFieldKeys.DEPENDENT_FIELD_FILTERS]: [],
  [FormFieldKeys.DESCRIPTION]: '',
  [FormFieldKeys.DISPLAY_ORDER]: -1,
  [FormFieldKeys.ENABLED]: true,
  [FormFieldKeys.FIELD_TYPE]: FieldTypes.TEXT,
  [FormFieldKeys.GROUP_NAME]: '',
  [FormFieldKeys.HIDDEN]: false,
  [FormFieldKeys.IS_SELECTED]: false,
  [FormFieldKeys.IS_SMART_FIELD]: false,
  [FormFieldKeys.META_DATA]: [],
  [FormFieldKeys.LABEL]: '',
  [FormFieldKeys.LABEL_HIDDEN]: false,
  [FormFieldKeys.NAME]: '',
  [FormFieldKeys.OBJECT_TYPE_ID]: FormFieldPropertyObjectTypesIds.COMPANY,
  [FormFieldKeys.TYPE]: FieldType.STRING,
  [FormFieldKeys.UNSELECTED_LABEL]: '',
  [FormFieldKeys.VALIDATION]: defaultValidation,
  [FormFieldKeys.PROPERTY_OBJECT_TYPE]: FormFieldPropertyObjectTypes.COMPANY,
  [FormFieldKeys.REQUIRED]: false,
  [FormFieldKeys.SELECTED_OPTIONS]: [],
  [FormFieldKeys.OPTIONS]: [],
  [FormFieldKeys.PLACEHOLDER]: ''
};
export default defaultDependentCompanyFormField;